module.exports = __webpack_public_path__ + "media/84.286808ed.mp3";